import { useMemo } from 'react';

import { type ConfirmOptions } from '@/shared/utils/confirm-store/confirm-store.types';
import { confirmStore } from '@/shared/utils/confirm-store/confirm-store.util';

export interface UseConfirm {
  /** Resolves `true` when accepted, `false` when dismissed or superseded. */
  confirm: (options?: ConfirmOptions) => Promise<boolean>;
}

/**
 * `await confirm({ … })` — a question read as a straight line of code.
 *
 * Deliberately does NOT subscribe to the store: a caller only ever asks, and
 * re-rendering every surface that owns a delete button each time the dialog's
 * pending flag flips would be pure waste. `ConfirmationRoot` is the one
 * subscriber.
 */
export function useConfirm(): UseConfirm {
  return useMemo(
    () => ({
      confirm: (options: ConfirmOptions = {}) => confirmStore.confirm(options),
    }),
    [],
  );
}
